<template>
    <tea-main @back="goBack">
        <template slot="nav">
            <div class="blackListNav">
                <div class="main_wrap">
                    <div class="left">
                        <p>课堂笔记</p>
                    </div>
                    <div class="zuxie-btn" @click="addFunc" v-if="userAvaible(['student'], userType)">上传课堂笔记</div>
                </div>
            </div>
        </template>
        <template slot="main">
            <div class="blackListMain">
                <div class="searchWrap">
                    <div class="search">
                        <div class="leisureBtn">
                            <!--  // 。。。 删除了部分-->
                        </div>
                        <div class="wrap">
                            <input v-model.lazy="search.keywords"
                                   type="text"
                                   placeholder="请输入搜索内容"
                                   @keyup.enter="getRequest">
                            <div v-show="search.keywords!=''"
                                 class="close"
                                 @click="hideIcon">
                                <v-icon name="regular/times-circle"
                                        scale="1.2"></v-icon>
                            </div>
                            <div class="searchBtn"
                                 @click="getRequest">搜索
                            </div>
                        </div>
                    </div>
                </div>
                <yioks-loading v-show="isLoading"></yioks-loading>
                <template v-if="!isLoading">
                    <template v-if="showList">
                        <div class="table">
                            <div class="thead">
                                <div class="tr">
                                    <div class="th index"><strong>序号</strong></div>
                                    <div class="th name"><strong>文件</strong></div>
                                    <div class="th banned_time"><strong>上传时间</strong></div>
                                    <div class="th opt"><strong>操作</strong></div>
                                </div>
                            </div>
                            <div class="scrollArea" v-if="showList">
                                <vue-scroll :ops="ops" ref="vs">
                                    <div class="tbodyWrap">
                                        <div class="tbody">
                                            <div class="tr"
                                                 v-for="(item, index) in tableList"
                                                 :key="index">
                                                <div class="td index" >
                                                    <p >{{index+1}}</p>
                                                </div>
                                                <div class="td name">
                                                    <p :title="item.document_title">{{item.document_title || '--'}}</p>
                                                </div>
                                                <div class="td banned_time">
                                                    <p>{{item.create_time | time}}</p>
                                                </div>
                                                <div class="td opt">
                                                    <span @click="lookOver(item)"><a :href="item.document_url" target="_blank">查看</a></span>
                                                    <span v-if="userAvaible(['student'], userType)">&nbsp;/&nbsp;</span>
                                                    <span @click="deleteOver(item)" v-if="userAvaible(['student'], userType)">删除</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </vue-scroll>
                            </div>
                        </div>
                        <div id="paging">
                            <yioks-paging :paging="paging"
                                          @goto-page="gotoPage($event)"></yioks-paging>
                        </div>
                    </template>
                    

                    <yioks-empty v-show="showEmpty"></yioks-empty>

                    <template v-if="showDeleteDialog">
                        <yioks-dialog :showTips.sync="showDeleteDialog" :tips="`确定删除该课堂笔记吗?`" @hideTips="hideDeleteDialog"></yioks-dialog>
                    </template>
                    <template v-if="add_show">
                        <add-dialog :showAddDialog="add_show" :Info="{}" @hideTips="hideAddDocumentTips"></add-dialog>
                    </template>
                </template>
            </div>
        </template>
    </tea-main>
</template>

<script>
    import { getDocumentList, deleteNotes } from '@/api/classNotes/document';
    import ops from '@/assets/js/vuescrollOption';
    import { storageData } from "@/assets/js/storage";
    import fiveMixins from "@/minix/fiveMixins";
    export default {
        name: "Documents",
      mixins: [fiveMixins],
        data() {
            return {
                tableList: [],
                documentDialog: {},
                t_show: false,
                addtitles: '',
                add_show: false,
                add_datas: {},
                // *********************
                ops: ops(),
                index:0,
              note_uuid:'',
              userType:storageData.getUserType(),
                name:'',
                isLoading: true,
                deleteLoading:false,
                showDeleteDialog:false,
                notEdit:false,
                Title:'详细信息',
                showList: false,
                showEmpty: false,
                Info:{},
                page: 1,
              c_id : this.$route.query.c_id,
              stu_id : this.$route.query.stu_id,
                paging: {
                    start: 0,
                    prePage: 1, // 一页多少条数据
                    total: 0, // 总页数
                    size: 3, // 页码显示限制
                    last: true, // 尾页
                    next: true, // 下一页
                    first: true, // 首页
                    previous: true, // 上一页
                    jump: true
                },
                search: {
                    keywords:'',
                },
            }
        },
        components: {
          
            "add-dialog": () => import('./components/AddDialog'),
            "tea-main": () => import("@/components/LayOut/Common/up-down"),
            "yioks-paging": () => import("@/components/Pagination/Page"),
            "yioks-empty": () => import("@/components/Tips/Empty"),
            "v-icon": () => import("vue-awesome/components/Icon"),
            "yioks-loading": () => import("@/components/Loading/Loading"),
            "yioks-verify": () => import("@/components/Tips/reviewDialog"),
            "yioks-dialog" : () => import("@/components/Tips/Dialog")

        },
        created() {
            this.setData();
            this.request();
        },
        methods: {
            // 修改
            addFunc() {
                this.add_show = true
            },
            // 查看详情
            lookOver(item) {
                const { note_uuid } = item;
              
            },
            // ************************************** end ****************************************
            setData(){
                const {page,keywords,user_id,c_id} = this.$route.query;
                page && (this.page = page);
                keywords && (this.$set(this.search, "keywords", keywords));
            },
            goBack() {
              this.$router.go(-1)
            },
            request() {
                this.isLoading = true;
              getDocumentList({"page": this.page, ...this.search,c_id:this.c_id,stu_id:this.stu_id})
                    .then(res=>{
                      if (res.data.status === 0) {
                        const { result } = res.data;
                        this.tableList = res.data.result.list;
                        this.showList = result.list.length > 0;
                        this.showEmpty = !this.showList;
                        this.isLoading = false;
                        this.$set(this.paging, "prePage", result.page.page_size);
                        this.$set(this.paging, "total", result.page.total_row);
                        this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
                      } else{
                            this.$message.error(res.data.msg);
                            this.isLoading = false;
                        }
                    })
                    .catch(err=>{
                        this.isLoading = false;
                        console.error(err);
                    })
            },
            hideIcon() {
                this.$set(this.search, "keywords", "");
                this.getRequest();
            },
            hideTimeIcon(){
                this.$set(this.search, "start_date", "");
                this.$set(this.search, "end_date", "");
                this.getRequest();
            },
            getRequest() {
                this.changeQuery(true);
            },
            gotoPage: function (start) {
                this.page = parseInt(start / this.paging.prePage) + 1;
                this.changeQuery(false);
                this.$refs['vs'].scrollTo({ y: 0 });
            },
            changeQuery(flag) {
                flag && (this.page = 1);
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.page,
                        keywords: this.search.keywords,
                    }
                });
                this.request();
            },
            deleteOver(item){
                 this.note_uuid=item.note_uuid;
                 this.showDeleteDialog=true;
            },

            hideDeleteDialog(bool,flag){
                if (flag){
                    this.deleteLoading=true;
                  deleteNotes({
                    uuid:this.note_uuid
                    }).then(res=>{
                        if (Number(res.data.status)===0){
                            this.$message.success('删除成功！')
                          this.request()
                        }else{
                            this.$message.error(res.data.msg)
                        }
                        this.deleteLoading=false;
                    }).catch(err=>{
                        this.deleteLoading=false;
                        this.showDeleteDialog=false
                    })
                }
                this.showDeleteDialog=bool;
            },
  
          hideAddDocumentTips(bool,flag){
                this.add_show = bool;
                if (flag){
                    this.$message.success('上传成功！')
                    this.request()
                }
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/assets/css/variable";
    @import "~@/assets/css/mixin";
    @import "~@/assets/css/nav_filter";
    .blackListNav, .blackListMain {
        flex: 1 1 auto;
        height: 100%;
    }
    .blackListNav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px 0 0;
        font-size: $font_size_big;
        .main_wrap{
            display: flex
            flex: 1
            justify-content: space-between
            align-items: center
            .left, .right{
                display: flex
                align-items: center
                .btn{
                    padding: 5px 15px;
                    cursor: pointer;
                    &.active{
                        background-color: $color_suc;
                    }
                    &+.btn{
                        margin-left: 10px
                    }
                }
            }

        }


    }

    .blackListMain {
        width: 100%;
        padding: 25px 0 0;
        background-color: $block_bg_color_base;
        .searchWrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            margin: 0 40px;
            .search {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .wrap {
                    height: 100%;
                    display flex
                    position: relative;
                    input {
                        width: 220px;
                        height: 100%;
                        padding: 0 20px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        outline: none;
                    }
                    .close {
                        position: absolute;
                        right: 95px;
                        top: 10px;
                        color: $color_info;
                        cursor: pointer;
                    }
                    .searchBtn {
                        width: 90px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 20px;
                        background-color: $color_suc;
                        cursor: pointer;

                    }
                }
                .leisureBtn{
                    position relative
                    display flex
                    height 100%
                    .close {
                        position: absolute;
                        right: 175px;
                        top: 10px;
                        color: $color_info;
                        cursor: pointer;
                    }
                    /*.timePicker{
                        border-radius 0
                        width 280px
                        margin-right 20px
                        span{
                            padding 0
                        }
                    }*/
                    select {
                        width: 150px;
                        height: 100%;
                        padding: 0 15px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        cursor pointer
                        outline: none;
                        &+select {
                            margin-left 15px
                        }
                    }
                }
            }
        }
        .table {
            width: 100%;
            margin: 30px 0 0;
            .thead, .tbody {
                border: 1px solid $color_white;
            }
            .thead {
                margin: 0 40px;
                .tr {
                    height: 45px;
                    display: flex;
                }
            }
            .scrollArea {
                height: 401px;
            }
            .tbodyWrap {
                display block
                margin-bottom 10px
                // padding: 0 40px;
            }
            .tbody {
                display block
                margin-left auto
                margin-right auto
                width: 810px;
                max-width: 810px;
                border-top: none;
                border-bottom: none;
                .tr {
                    height: 49px;
                    display: flex;
                    border-bottom: 1px solid $color_white;
                }
            }
            .th, .td {
                height: 100%;
                flex: 1 1 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                border-right: 1px solid $color_white;
            }
            .th:last-child, .td:last-child {
                border-right: none;
            }
            .td:last-child {
                color: $color_suc;
                user-select: none;
            }
            
            .td {
                p {
                    over_hide();
                }
                .showRecord{
                    cursor pointer
                }
            }
            .index{
                width:6%;
            }
            .name {
                width: 36%;
            }
            .banned_time {
                width: 14%;
            }
            .opt {
                width: 10%;
                span{
                    cursor: pointer;
                    color: $color_suc;
                }
            }
        }
        #paging {
            width: 100%;
            height: 77px;
        }
    }


</style>

<style lang="stylus" >
    .blackListMain{
        .el-date-editor .el-range-separator{
            padding 0
        }
        .__vuescroll .__view{
            min-height 96%
        }
    }

</style>
